import React from 'react';
import PropTypes from 'prop-types';

import {
  activate,
  deactivate,
  setShortcutVisible,
  setHeadline,
  setTheme,
  bulkUpdate,
} from 'redux/modules/navbar';

import BTE from 'lib/BTE';

export const NAVBAR_THEME = {
  TRANSPARENT: 'transparent',
  TRANSPARENT_LIGHT: 'transparentLight',
  LIGHT: 'light',
  DARK: 'dark',
  VERTICAL: 'vertical',
};

export default ({
  theme: getTheme,
  headline: getHeadline,
  activeAt,
  showShortcuts,
  view: getView,
}) => (Page) => class extends React.Component {
  static WrappedComponent = Page;

  static fetchDataDeferred(_, { dispatch }) {
    dispatch(deactivate());
  }

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
  };

  static contextTypes = {
    store: PropTypes.shape({}),
  };

  static defaultProps = {
    children: null,
  };

  componentDidMount() {
    const { store } = this.context;
    const state = store.getState();

    this.setShowShortcuts(state);
    this.setTheme(state);
    this.setHeadline(state);

    BTE.on('scroll', this.monitorScroll, 'throttle');
  }

  componentWillUnmount() {
    BTE.remove('scroll', this.monitorScroll, 'throttle');
  }

  setView = (data) => {
    const { store } = this.context;
    const state = store.getState();
    const view = getView && getView(state, data);
    if (view) {
      store.dispatch(bulkUpdate(view));
    }
  }

  monitorScroll = (depth) => {
    const { store } = this.context;
    const state = store.getState();
    const { watchScroll, active } = state.navbar;

    if (watchScroll) {
      if (depth > activeAt && !active) {
        store.dispatch(activate());
      } else if (depth < activeAt && active) {
        store.dispatch(deactivate());
      }
    }
  }

  setShowShortcuts = (state) => {
    const { store } = this.context;
    const shouldShowShortcuts = typeof showShortcuts === 'function'
      ? showShortcuts(state)
      : showShortcuts;
    const setShortcutsVisible = setShortcutVisible(shouldShowShortcuts);
    store.dispatch(setShortcutsVisible);
  }

  setTheme = (state) => {
    if (getTheme) {
      const { store } = this.context;
      const theme = getTheme(state);
      const setNavbarTheme = setTheme(theme);
      store.dispatch(setNavbarTheme);
    }
  }

  setHeadline = (state) => {
    if (getHeadline) {
      const { store } = this.context;
      const headline = getHeadline(state);
      const setNavbarHeadline = setHeadline(headline);
      store.dispatch(setNavbarHeadline);
    }
  }

  render() {
    const { children } = this.props;
    return (
      <Page {...this.props} onView={this.setView}>
        {children}
      </Page>
    );
  }
};
